<script>
import QRCode from 'qrcode'

export default {
  props: {
    text: {
      type: String,
      require: true,
      default: '',
    },
  },
  methods: {
    async handleDownloadQrCode() {
      const opts = {
        erroCorrectionLevel: 'H',
        type: 'image/png',
        with: 100,
        height: 100,
        color: {
          dark: '#000000',
          light: '#ffffff',
        },
      }
      try {
        const canvasElement = document.createElement('canvas', { id: 'canvas' })
        await QRCode.toCanvas(canvasElement, this.text, opts)
        const link = document.createElement('a')
        link.href = canvasElement.toDataURL('image/png')
        link.download = this.text + '_QrCode.png'
        link.click()
        window.URL.revokeObjectURL(link.href)
      } catch (error) {}
    },
  },
}
</script>

<template>
  <CButton
    v-bind="$attrs"
    color="dark"
    variant="outline"
    class="py-0 mb-2"
    @click="handleDownloadQrCode"
  >
    {{ $t('common.qrCode') }}</CButton
  >
</template>
